import { render, staticRenderFns } from "./NoticeManagement.vue?vue&type=template&id=4d58f154&scoped=true&"
import script from "./NoticeManagement.vue?vue&type=script&lang=js&"
export * from "./NoticeManagement.vue?vue&type=script&lang=js&"
import style0 from "./NoticeManagement.vue?vue&type=style&index=0&id=4d58f154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58f154",
  null
  
)

export default component.exports